import { includes } from 'lodash';

// Emails of engineering and product team members
// used to enable engineering support features i.e. rerunning portal form submissions
const ENGINEERING_SUPPORT_EMAILS = [
  'andrew@beaconcrm.org',
  'charles@beaconcrm.org',
  'chris@beaconcrm.org',
  'david@beaconcrm.org',
  'fares@beaconcrm.org',
  'haydn@beaconcrm.org',
  'james@beaconcrm.org',
  'orian@beaconcrm.org',
  'philip@beaconcrm.org',
  'richard@beaconcrm.org',
  'sam@beaconcrm.org',
  'samir@beaconcrm.org',
  'stuart@beaconcrm.org',
];

export default (userEmail) => includes(ENGINEERING_SUPPORT_EMAILS, userEmail);
